module.exports = __webpack_public_path__ + "static/media/correct.a4dd8c96.mp3";